import { css } from '@emotion/css';

export const styTable = css`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0px;
  white-space: nowrap;
`;
